var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIlluLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 765,
    height: 1833.016,
    viewBox: "0 0 765 1833.016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_78",
    x: 0,
    y: 1728.016,
    width: 765,
    height: 105,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4c75fa",
    floodOpacity: 0.698,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.474,
    y2: 0.982,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.051
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Vereinigungsmenge_3",
    x: 186.035,
    y: 1367.855,
    width: 392.931,
    height: 431.564,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.29
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3842",
    "data-name": "Gruppe 3842",
    transform: "translate(-1003 895.508)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_78-2",
    "data-name": "Ellipse 78",
    cx: 382.5,
    cy: 52.5,
    rx: 382.5,
    ry: 52.5,
    transform: "translate(1003 832.508)",
    fill: "#a3b2bf"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1003, -895.51)",
    filter: "url(#Ellipse_78)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_78-3",
    "data-name": "Ellipse 78",
    cx: 382.5,
    cy: 52.5,
    rx: 382.5,
    ry: 52.5,
    transform: "translate(0 1728.02)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3742",
    "data-name": "Pfad 3742",
    d: "M273.214,0H491.786L765,1572.033H0Z",
    transform: "translate(1003 -895.508)",
    opacity: 0.137,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1003, -895.51)",
    filter: "url(#Vereinigungsmenge_3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_3-2",
    "data-name": "Vereinigungsmenge 3",
    d: "M-777.5,152.3l152.486-92.371,153.188,97.237-153.634,74.542Zm153.132-93.486-.859-173.1,145.19,104.5,8.726,165.9ZM-763.9-11.365l138.426-103.053.2,172.695V58.5l-152.835,92.547Z",
    transform: "matrix(1, 0.02, -0.02, 1, 1008.14, 1535.9)",
    fill: "#fff",
    stroke: "#476eed",
    strokeLinejoin: "round",
    strokeWidth: 8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlluLogin);
export default __webpack_public_path__ + "static/media/Illu-Login.ca2a569d1ab826bb65e72d34f4dadb32.svg";
export { ForwardRef as ReactComponent };